import { FormEvent, useContext, useState, useEffect, JSX } from 'react';
import { WorkflowContext } from "../../context/WorkflowContextProvider";
import Form from '@rjsf/mui';
import { IChangeEvent } from '@rjsf/core';
import { RJSFSchema, UiSchema, RegistryWidgetsType } from '@rjsf/utils';
import validator from '@rjsf/validator-ajv8';
import {useReactFlow, applyNodeChanges, ReactFlowInstance } from "@xyflow/react";
import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/Delete';
import { NodeDataStoreSelectWidget } from "./components/NodeDataStoreSelectWidget";
import { DefaultFormDialog  } from "./components/DefaultFormDialog";
import { processNodeDelete, processNodeFormSubmit, formSchema, nodeDescription } from "./functions/workflow-hq-fetch-node-configuration";
import {
    Button
} from '@mui/material';

export const WorkflowHQFetchNodeConfiguration: () => JSX.Element = (): JSX.Element => {
    const context: any = useContext(WorkflowContext);
    const reactFlowInstance: ReactFlowInstance = useReactFlow();
    const [formData, setFormData] = useState<any>();

    function handleCloseDialog(): void {
        context.toggleShowHQFetchModal(false);
    }

    const handleFormSubmit: (data: IChangeEvent, event: FormEvent<any>) => void = (data: IChangeEvent, event: FormEvent<any>) : void => {
        console.log(data.formData);
        processNodeFormSubmit(context, data.formData, reactFlowInstance);
        handleCloseDialog();
    }

    function deleteNode(): void {
        processNodeDelete(context, reactFlowInstance);
        handleCloseDialog();
    }


    const uiSchema: UiSchema = {
        'data_input': {
            'ui:widget': 'NodeDataStoreSelectWidget',
            'ui:options': {
                'classNames': 'data-management',
                enumDisabled: [
                    'messages',
                    'latest_user_message',
                    'scraper_pending'
                ]
            }
        },
        'data_management': {
            'ui:widget': 'NodeDataStoreSelectWidget',
            'ui:options': {
                'classNames': 'data-management',
                enumDisabled: [
                    'hq_params',
                    'data_to_loop',
                    'latest_user_message',
                    'scraper_pending'
                ]
            }
        },
        'entity_data': {
            'action_data': {
                'update_location': {
                    'ui:widget': 'NodeDataStoreSelectWidget',
                    'ui:options': {
                        'classNames': 'data-management',
                        enumDisabled: [
                            'messages',
                            'scraper_pending'
                        ]
                    }
                },
                'create_location': {
                    'ui:widget': 'NodeDataStoreSelectWidget',
                    'ui:options': {
                        'classNames': 'data-management',
                        enumDisabled: [
                            'messages',
                            'scraper_pending'
                        ]
                    }
                },
                'get_location': {
                    'ui:widget': 'NodeDataStoreSelectWidget',
                    'ui:options': {
                        'classNames': 'data-management',
                        enumDisabled: [
                            'messages',
                            'scraper_pending'
                        ]
                    }
                }
            }
        },
        'ui:order': [
            'data_input',
            'entity_or_action',
            'entity_data',
            'entity_type' ,
            'allOf',
            'action_type',
            'get_location',
            'create_location',
            'update_location',
            'custom_action',
            'data_management',
            'add_output_to_message'
        ]
    }

    const widgets: RegistryWidgetsType = {
        NodeDataStoreSelectWidget: NodeDataStoreSelectWidget
    }

    useEffect( () => {
        if (context.activeEditHQFetchNode !== undefined && context.activeEditHQFetchNode.data !== undefined) {
            setFormData(context.activeEditHQFetchNode.data);
        }
    } , [context] );



    return (
        <DefaultFormDialog
            open={ context.showHQFetchModal }
            title={ "HQ Fetch Data Node" }
            handleClose={ handleCloseDialog }
            description={ nodeDescription }
        >
            <span style={ { paddingLeft: '15px', fontWeight: 'bold' } }>{ "Node ID: " + context?.activeEditHQFetchNode?.id }</span>
            <Form
                validator={validator}
                schema={ formSchema }
                uiSchema={ uiSchema }
                onSubmit={ handleFormSubmit }
                widgets={ widgets }
                id="workflow-scraper-node-configure"
                formData={ formData }
                formContext={ formData }
                onChange={({ formData }) => setFormData(formData)}
            >
                <div className="dialog__actions form-group">
                    <Button type="submit"
                            variant="contained"
                            color="success"
                    >
                        <SaveIcon />
                        <span>{ "Save" }</span>
                    </Button>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={ deleteNode }
                        type="button">
                        <DeleteIcon />
                        <span>{ "Delete" }</span>
                    </Button>
                </div>
            </Form>
        </DefaultFormDialog>
    );
}